const APP_SCROLL_ROOT_ID = 'app-scroll-root';
const PENDING_SCROLL_KEY = 'landingPendingScroll';
const LANDING_HEADER_SELECTOR = '[data-landing-header]';
const ANCHOR_SCROLL_GAP = 8;
const DESKTOP_MIN_WIDTH = 821;

export function getAppScrollRoot() {
  return document.getElementById(APP_SCROLL_ROOT_ID);
}

export function getLandingHeaderOffset() {
  if (typeof window !== 'undefined' && window.innerWidth < DESKTOP_MIN_WIDTH) {
    return 0;
  }

  const cssVar = getComputedStyle(document.documentElement)
    .getPropertyValue('--landing-header-height')
    .trim();
  const parsed = Number.parseFloat(cssVar);
  if (Number.isFinite(parsed) && parsed > 0) {
    return Math.ceil(parsed) + ANCHOR_SCROLL_GAP;
  }

  const header = document.querySelector(LANDING_HEADER_SELECTOR);
  if (!header) return 0;
  return Math.ceil(header.getBoundingClientRect().height) + ANCHOR_SCROLL_GAP;
}

export function scrollToLandingSection(hash) {
  const id = (hash || '').replace(/^#/, '');
  if (!id) return false;

  const target = document.getElementById(id);
  const scrollRoot = getAppScrollRoot();
  if (!target || !scrollRoot) return false;

  const headerOffset = getLandingHeaderOffset();
  const targetTop = target.getBoundingClientRect().top;
  const rootTop = scrollRoot.getBoundingClientRect().top;
  const nextTop = scrollRoot.scrollTop + targetTop - rootTop - headerOffset;

  scrollRoot.scrollTo({
    top: Math.max(0, nextTop),
    behavior: 'smooth',
  });

  return true;
}

export function queueLandingSectionScroll(hash) {
  if (!hash) return;
  sessionStorage.setItem(PENDING_SCROLL_KEY, hash);
}

export function consumeLandingSectionScroll() {
  const hash = sessionStorage.getItem(PENDING_SCROLL_KEY);
  if (!hash) return;

  sessionStorage.removeItem(PENDING_SCROLL_KEY);

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      scrollToLandingSection(hash);
    });
  });
}

export function handleLandingAnchorClick(event, href, { navigate, anchorPrefix = '' } = {}) {
  const hashIndex = href.indexOf('#');
  if (hashIndex === -1) return;

  event.preventDefault();

  const hash = href.slice(hashIndex);
  const pathPart = href.slice(0, hashIndex) || '/';
  const wantsHome = pathPart === '/' || pathPart === '';
  const onLanding = window.location.pathname === '/';

  if (onLanding && wantsHome) {
    scrollToLandingSection(hash);
    window.history.replaceState(null, '', `${window.location.pathname}${hash}`);
    return;
  }

  if (wantsHome && typeof navigate === 'function') {
    queueLandingSectionScroll(hash);
    navigate('/');
    return;
  }

  window.location.href = href;
}
